import React from 'react';
import { Hero } from './components/Hero';
import { Problem } from './components/Problem';
import { Modules } from './components/Modules';
import { TriadAndBonuses } from './components/TriadAndBonuses';
import { Offer } from './components/Offer';
import { Footer } from './components/Footer';
export function App() {
  return <div className="w-full min-h-screen bg-brand-dark text-white font-sans antialiased" data-id="element-0">
      <main data-id="element-1">
        <Hero data-id="element-2" />
        <Problem data-id="element-3" />
        <Modules data-id="element-4" />
        <TriadAndBonuses data-id="element-5" />
        <Offer data-id="element-6" />
      </main>
      <Footer data-id="element-7" />
    </div>;
}